var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"Styles") : depth0)) != null ? lookupProperty(stack1,"message-container") : stack1), depth0))
    + "\">\n    "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"confirmMessage") || (depth0 != null ? lookupProperty(depth0,"confirmMessage") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"confirmMessage","hash":{},"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":2,"column":24}}}) : helper))) != null ? stack1 : "")
    + "\n</div>\n";
},"useData":true});